import {
  DETAILS_LOADING,
  DETAILS_SUCCESS,
  DETAILS_ERROR,
  DETAILS_SEARCH,
  DETAILS_FAILED
} from '../actions/benefitDetailsActions.js'

const searchDetails = (all, s = '') => {
  const copy = Object.assign({}, all)
  const search = s.toLowerCase()
  if (!search) {
    return all
  } else {
    copy.coInsuranceList = copy.coInsuranceList.filter(obj => { return obj.description.toLowerCase().indexOf(search) >= 0 })
    copy.dollarMaximumList = copy.dollarMaximumList.filter(obj => { return obj.categoryDescription.toLowerCase().indexOf(search) >= 0 })
    copy.unitMaximumList = copy.unitMaximumList.filter(obj => { return obj.categoryDescription.toLowerCase().indexOf(search) >= 0 })
    copy.deductibleItems = copy.deductibleItems.filter(obj => { return obj.description.toLowerCase().indexOf(search) >= 0 })
    copy.coPayItems = copy.coPayItems.filter(obj => { return obj.description.toLowerCase().indexOf(search) >= 0 })
    return copy
  }
}

const BenefitDetails = (state = {
  isFetching: false,
  error: null,
  detailsData: {}
}, action) => {
  switch (action.type) {
    case DETAILS_LOADING:
      return Object.assign({}, state, {
        isFetching: true,
        detailsData: null,
        error: null
      })
    case DETAILS_SUCCESS:
      let successSearched = searchDetails(action.response, state.searchObj)
      return Object.assign({}, state, {
        isFetching: false,
        detailsData: successSearched,
        allDetailsData: action.response,
        error: null,
        detailsSearched: false
      })
    case DETAILS_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
        detailsData: null
      })
    case DETAILS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
        detailsData: {}
      })
    case DETAILS_SEARCH:
      let searchedDetails = searchDetails(state.allDetailsData, action.searchObj)
      return Object.assign({}, state, {
        detailsData: searchedDetails,
        searchObj: action.searchObj,
        detailsSearched: true
      })
    default:
      return state
  }
}

export default BenefitDetails



// WEBPACK FOOTER //
// ./src/redux/reducers/benefitDetailsReducer.js